import { Box } from '@gemini/core';
import UpdateCard from '@mfe-presentation/components/UpdateCard';
import FieldWrapper from '@mfe-presentation/components/Wrappers/FieldWrapper';
import { useAppContext } from '@mfe-presentation/contexts';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const UpdateForm = () => {
    const { config, formValues, portal } = useAppContext();
    const fields = config['update'].getFields(formValues);
    const { t } = useTranslation(NAME_SPACE);
    const { control } = useFormContext();
    const isAPrivatePerson = useWatch({ control, name: 'isAPrivatePerson' });
    const {
        estateType,
        numberOfRooms,
        numberOfBedRooms,
        livingSurface,
        cityName,
        houseNumber = '',
        postalCode,
        streetName,
    } = formValues;

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box>
                <UpdateCard
                    estateType={estateType}
                    numberOfRooms={numberOfRooms}
                    numberOfBedRooms={numberOfBedRooms}
                    livingSurface={livingSurface}
                    cityName={cityName}
                    houseNumber={houseNumber}
                    postalCode={postalCode}
                    streetName={streetName}
                    portal={portal}
                />
                <Box display="flex" flexDirection="column" marginVertical="spacing.32">
                    {Object.entries(fields).map(([key, value]) => (
                        <FieldWrapper field={value} name={key} key={key} />
                    ))}
                    {isAPrivatePerson && (
                        <Box as="p" typography="typography.body.14.regular">
                            {t('step_profile.legalText')}
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default UpdateForm;
